export const zakladki = {
    "zakladki": {
      "@ile": "5",
      "items": [
        {
          "@ile": "1",
          "item": [
            {
              "nazwa": "Zima 2025",
              "pozycja": "1-A",
              "link": "/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-10&terminDo=2025-03-30",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Austria",
              "pozycja": "1-B",
              "link": "www.austria.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-10&terminDo=2025-03-30",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Włochy",
              "pozycja": "1-C",
              "link": "www.wlochy.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-10&terminDo=2025-03-30",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Francja",
              "pozycja": "1-D",
              "link": "www.francja.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-10&terminDo=2025-03-30",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Słowacja",
              "pozycja": "1-E",
              "link": "www.slowacja.com.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-10&terminDo=2025-03-30",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Czechy",
              "pozycja": "1-F",
              "link": "www.czechy.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-10&terminDo=2025-03-30",
              "geourl": [],
              "target": [],
              "follow": []
            }
          ]
        },
        {
          "@ile": "2",
          "item": [
            {
              "nazwa": "Free Ski",
              "pozycja": "2-A",
              "link": "/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-10&terminDo=2025-03-30&candy=4",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Austria",
              "pozycja": "2-B",
              "link": "www.austria.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-10&terminDo=2025-03-30&candy=4",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Włochy",
              "pozycja": "2-C",
              "link": "www.wlochy.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-10&terminDo=2025-03-30&candy=4",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Francja",
              "pozycja": "2-D",
              "link": "www.francja.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-10&terminDo=2025-03-30&candy=4",
              "geourl": [],
              "target": [],
              "follow": []
            }
          ]
        },
        {
          "@ile": "3",
          "item": [
            {
              "nazwa": "Ferie Zimowe",
              "pozycja": "3-A",
              "link": "/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-16&terminDo=2025-02-25",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Austria",
              "pozycja": "3-B",
              "link": "www.austria.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-16&terminDo=2025-02-25",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Włochy",
              "pozycja": "3-C",
              "link": "www.wlochy.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-16&terminDo=2025-02-25",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Francja",
              "pozycja": "3-D",
              "link": "www.francja.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-16&terminDo=2025-02-25",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Słowacja",
              "pozycja": "3-E",
              "link": "www.slowacja.com.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-16&terminDo=2025-02-25",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Czechy",
              "pozycja": "3-F",
              "link": "www.czechy.pl/oferta/szukaj.xml?extern=1&noMTO=FTON&adt=2&pobyt=6,8&udog=90000002&udor=0&termin=2025-01-16&terminDo=2025-02-25",
              "geourl": [],
              "target": [],
              "follow": []
            }
          ]
        },
        {
          "@ile": "5",
          "item": [
            {
              "nazwa": "Hotele",
              "pozycja": "5-A",
              "link": "www.hotelone.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Czechy",
              "pozycja": "5-B",
              "link": "www.hotele.czechy.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Francja",
              "pozycja": "5-C",
              "link": "www.hotele.francja.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Hiszpania",
              "pozycja": "5-D",
              "link": "www.hotele.hiszpania.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Włochy",
              "pozycja": "5-E",
              "link": "www.hotele.wlochy.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Portugalia",
              "pozycja": "5-F",
              "link": "www.hotele.portugalia.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Wielka Brytania",
              "pozycja": "5-G",
              "link": "www.hotele.wielkabrytania.com.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            },
            {
              "nazwa": "Stany Zjednoczone",
              "pozycja": "5-H",
              "link": "www.hotele.stanyzjednoczone.pl/",
              "geourl": [],
              "target": [],
              "follow": []
            }
          ]
        }
      ]
    }
}
